import { Button, Tooltip } from "@100mslive/react-ui";
import {
  useIsHLSStartedFromUI,
  useIsRTMPStartedFromUI,
} from "./AppData/useUISettings";
import {
  useIsSidepaneTypeOpen,
  useSidepaneToggle,
} from "./AppData/useSidepane";

import { GoLiveIcon } from "@100mslive/react-icons";
import { SIDE_PANE_OPTIONS } from "./../common/constants";
import { useRecordingStreaming } from "@100mslive/react-sdk";

const GoLiveButton = () => {
  const isStreamingSidepaneOpen = useIsSidepaneTypeOpen(
    SIDE_PANE_OPTIONS.STREAMING
  );
  const toggleStreaming = useSidepaneToggle(SIDE_PANE_OPTIONS.STREAMING);
  const { isStreamingOn, isBrowserRecordingOn } = useRecordingStreaming();
  const isHLSStartedFromUI = useIsHLSStartedFromUI();
  const isRTMPStartedFromUI = useIsRTMPStartedFromUI();
  let tooltipText = "Lựa chọn tính năng phát trực tiếp";
  if (isHLSStartedFromUI || isRTMPStartedFromUI) {
    if (isHLSStartedFromUI) {
      tooltipText = "Tiến trình Live";
    }
    if (isRTMPStartedFromUI) {
      tooltipText = "Tiến trình RTMP";
    }
  }
  return (
    <Tooltip title={tooltipText}>
      <Button
        data-testid="go_live"
        variant={isStreamingSidepaneOpen ? "standard" : "primary"}
        onClick={() => {
          toggleStreaming();
          window.sessionStorage.setItem("userStartedStream", "true");
        }}
        icon
        loading={isRTMPStartedFromUI || isHLSStartedFromUI}
        disabled={isBrowserRecordingOn && !isStreamingOn}
      >
        <GoLiveIcon />
        Phát trực tiếp
      </Button>
    </Tooltip>
  );
};

export default GoLiveButton;
